<app-header-one [sticky]="false" *ngIf="url != '/pages/comingsoon'"></app-header-one>
<router-outlet></router-outlet>
<app-footer-two *ngIf="url != '/pages/comingsoon'"></app-footer-two>
